export const SIGN_IN = 'signIn';
export const SIGN_OUT = 'signOut';
export const START_APP = 'startApp';
export const DISPLAY_MESSAGE = 'displayMessage';
export const DISPLAY_ERROR = 'displayError';
export const DISPLAY_WARNING = 'displayWarning';
export const SET_MOLECULES = 'setMolecules';
export const SET_BRANDED_DRUGS = 'setBrandedDrugs';
